import posthog from 'posthog-js';

// Initialize PostHog
export const initPostHog = () => {
  // Only initialize in production or if explicitly enabled
  if (import.meta.env.VITE_POSTHOG_KEY && import.meta.env.VITE_POSTHOG_HOST) {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_POSTHOG_HOST,
      person_profiles: 'identified_only', // Only create profiles for identified users
      capture_pageview: true, // Automatically capture page views
      capture_pageleave: true, // Track when users leave pages
      autocapture: {
        dom_event_allowlist: ['click', 'submit', 'change'], // Track these DOM events
        element_allowlist: ['button', 'input', 'select', 'textarea', 'a'], // Track these elements
      },
      session_recording: {
        enabled: false, // Disable session recording for privacy
      },
    });
  }
};

// Identify user
export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (posthog.isFeatureEnabled === undefined) return; // PostHog not initialized
  
  posthog.identify(userId, {
    ...properties,
    app_version: import.meta.env.VITE_APP_VERSION || 'unknown',
  });
};

// Track custom events
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (posthog.isFeatureEnabled === undefined) return; // PostHog not initialized
  
  posthog.capture(eventName, properties);
};

// Track feature usage
export const trackFeatureUsage = (featureName: string, action: string, properties?: Record<string, any>) => {
  trackEvent(`feature_${featureName}_${action}`, {
    feature: featureName,
    action: action,
    ...properties,
  });
};

// Track page views with custom properties
export const trackPageView = (pageName: string, properties?: Record<string, any>) => {
  trackEvent('$pageview', {
    page_name: pageName,
    ...properties,
  });
};

// Track errors
export const trackError = (error: Error | string, context?: Record<string, any>) => {
  trackEvent('error_occurred', {
    error_message: error instanceof Error ? error.message : error,
    error_stack: error instanceof Error ? error.stack : undefined,
    ...context,
  });
};

// Reset user (on logout)
export const resetUser = () => {
  if (posthog.isFeatureEnabled === undefined) return; // PostHog not initialized
  
  posthog.reset();
};

// Export PostHog instance for advanced usage
export default posthog;